import { render, staticRenderFns } from "./Eventos.vue?vue&type=template&id=3630f7ae&scoped=true"
import script from "./Eventos.vue?vue&type=script&lang=js"
export * from "./Eventos.vue?vue&type=script&lang=js"
import style0 from "./Eventos.vue?vue&type=style&index=0&id=3630f7ae&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3630f7ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian-bitbucket-pipelines-runner/8cc7fca4-30ca-5724-915b-9e55d5143525/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3630f7ae')) {
      api.createRecord('3630f7ae', component.options)
    } else {
      api.reload('3630f7ae', component.options)
    }
    module.hot.accept("./Eventos.vue?vue&type=template&id=3630f7ae&scoped=true", function () {
      api.rerender('3630f7ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Views/EstadosMobile/Eventos.vue"
export default component.exports